<ng-container *ngSubscribe="editMode$ as editMode">
  <ng-container *ngIf="!isAreaHero && editMode">
    <div *ngIf="hasUserPermissionToEdit$ | async as hasUserPermissionToEdit" class="row justify-content-between">
      <div class="col-auto">
        <a mat-flat-button color="accent" [routerLink]="['',{ outlets: { modal: ['infoboxes','add'] } }]" [queryParams]="{'area':area, 'route':routerUrl}" i18n="@@infoboxes-add-new-editmode">Add new infobox here</a>
      </div>
      <div class="col-auto align-self-center">
        <span class="bolder mr-1">Area:</span>{{area}}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isAreaHero && editMode">
    <ng-container *ngIf="hasUserPermissionToEdit$ | async as hasUserPermissionToEdit">
      <div class="row mb-3 mt-3">
        <div class="ml-2">
          <a mat-flat-button color="accent" [routerLink]="['',{ outlets: { modal: ['infoboxes','add'] } }]" [queryParams]="{'area':area, 'route':router.url}" i18n="@@infoboxes-add-new-editmode">Add new infobox here</a>
        </div>
        <div class="ml-auto mt-2 mr-3" *ngIf="editMode">
          <span class="bolder">Area:</span>{{area}}
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div *ngIf="boxes$ | async as boxes;else loading" class="infobox-container row" [sortablejs]="editMode ? boxes : []" [sortablejsOptions]="editMode ? options : {disabled:true}">
    <div *ngFor="let box of boxes" class="infobox" [ngClass]="[
       getWidthClasses(box),
       isAreaHero ? 'hero col pl-0 pr-0': 'col pt-3 pb-3',
       box.Height === 1 ? 'compact': '']">
      <div class="edit-menu" *ngIf="editMode">
        <div class="float-left">
          <i title="Move infobox" i18n-title="@@infobox-move-icon-title" class="ms-Icon ms-Icon--Move move-icon" aria-hidden="true"></i>
        </div>
        <div class="float-right">
          <button mat-icon-button [matMenuTriggerFor]="menu" [matMenuTriggerData]="{data: box}">
            <i title="Infobox actions" i18n-title="@@infobox-actions-icon-title" class="ms-Icon ms-Icon--More" aria-hidden="true"></i>
          </button>
        </div>
        <div class="float-right">
          <button mat-icon-button [matMenuTriggerFor]="sizeMenu" [matMenuTriggerData]="{data:box}">
            <i title="Change infobox width" i18n-title="@@infobox-width-icon-title" class="ms-Icon ms-Icon--FitWidth" aria-hidden="true"></i>
          </button>
        </div>
        <div class="date">
          <span *ngIf="box.StartDateAsDate">{{box.StartDateAsDate | date:'short'}}</span>
          <span *ngIf="box.StartDateAsDate || box.EndDateAsDate"> - </span>
          <span *ngIf="box.EndDateAsDate">{{box.EndDateAsDate | date:'short'}}</span>
        </div>
      </div>
      <app-infobox [box]="box" [isAreaHero]="isAreaHero" [textAlignmentClass]="textAlignmentClass"></app-infobox>
    </div>
  </div>

</ng-container>

<ng-template #loading>
  <div>
    <app-widget-placeholder></app-widget-placeholder>
  </div>
</ng-template>

<mat-menu #sizeMenu="matMenu" [xPosition]="'before'" [overlapTrigger]="'false'">
  <ng-template matMenuContent let-data="data">
    <button mat-menu-item (click)="setSize(0,data)"><span [ngClass]="data.Width === 0 ? 'font-weight-bold' : ''">Auto</span></button>
    <button mat-menu-item (click)="setSize(25,data)"><span [ngClass]="data.Width === 25 ? 'font-weight-bold' : ''">25%</span></button>
    <button mat-menu-item (click)="setSize(33,data)"><span [ngClass]="data.Width === 33 ? 'font-weight-bold' : ''">33%</span></button>
    <button mat-menu-item (click)="setSize(50,data)"><span [ngClass]="data.Width === 50 ? 'font-weight-bold' : ''">50%</span></button>
    <button mat-menu-item (click)="setSize(66,data)"><span [ngClass]="data.Width === 66 ? 'font-weight-bold' : ''">66%</span></button>
    <button mat-menu-item (click)="setSize(75,data)"><span [ngClass]="data.Width === 75 ? 'font-weight-bold' : ''">75%</span></button>
    <button mat-menu-item (click)="setSize(100,data)"><span [ngClass]="data.Width === 100 ? 'font-weight-bold' : ''">100%</span></button>
  </ng-template>
</mat-menu>


<mat-menu #menu="matMenu" [xPosition]="'before'" [overlapTrigger]="'false'">
  <ng-template matMenuContent let-data="data">
    <a mat-menu-item [routerLink]="['',{ outlets: { modal: ['infoboxes','edit',data.Id] } }]" i18n="@@edit">Edit</a>
    <button mat-menu-item (click)="duplicate(data)" i18n="@@duplicate">Duplicate</button>
    <button mat-menu-item (click)="hide(data)" i18n="@@remove">Remove</button>
  </ng-template>
</mat-menu>
